import { render, staticRenderFns } from "./SendMessageTargetFamilyModal.vue?vue&type=template&id=cf8516ec&lang=pug"
import script from "./SendMessageTargetFamilyModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetFamilyModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetFamilyModal.vue?vue&type=style&index=0&id=cf8516ec&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports